import * as types from '../constants/ActionTypes';

const initState = {
  isLoading: true,
  error: false,
  experience: undefined,
  topics: [],
};

export default function (state = initState, action) {
  switch (action.type) {
    case types.REQUEST_TOPIC_TREE:
      return { ...state, isLoading: true, error: false };
    case types.RESPONSE_TOPIC_TREE:
      return {
        ...state,
        topics: action.payload.topics,
        blacklistedMarketICFFlag: action.payload.blacklistedMarketICFFlag,
        isLoading: false,
        error: false,
        experience: action.payload.experience,
      };
    case types.ERROR_TOPIC_TREE:
      return { ...state, isLoading: false, error: true };
    default:
      return state;
  }
}
